import { normalizeUri } from '../../../utils/utils';
export function toItem(item) {
  return {
    id: getItemId(item.uri),
    name: item.name,
    kind: 'file',
    mediaType: 'video',
    source: 'vimeo',
    thumbnailUrl: item.pictures.base_link,
    previewUrl: normalizeUri(item.uri),
    fileUrl: normalizeUri(item.uri)
  };
}
function getItemId(uri) {
  const regex = /\d+/g;
  return regex.exec(uri)[0];
}